// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.err[data-v-c5d3c424] {\n  margin-top: 2px !important;\n  color: #eb5757;\n  font-size: 12px;\n  min-height: 20px;\n  white-space: nowrap;\n  margin-bottom: -30px;\n  line-height: 20px;\n  font-weight: 500;\n  padding-left: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
